import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-7.06 2.121-2.122 1.06 1.06L11.062 10l2.12 2.121-1.06 1.06L10 11.062l-2.121 2.12-1.061-1.06L8.939 10 6.818 7.879l1.06-1.061z"
    }, null, -1)
  ])))
}
export default { render: render }